function jvzooCarousel(element, data,itemsPerSlide){
    this.element = element;
    this.data = data;
    this.currentIndex = 0;
    this.itemsPerSlide = itemsPerSlide;
    this.timesClicked = 1;
    this.resizeTimer;
    this.currentShownItems;
    //add next and previous selectors here.
}

jvzooCarousel.prototype.next = function(){
    var nextItem = $(this.element +' '+ '.nextItem');
    var _this = this;

    $(nextItem).click(function(){
        // console.log(_this.currentIndex);
        /*
        var division = Math.ceil(_this.data.length / _this.itemsPerSlide);
        console.log(division + ' is divider');
        console.log(_this.timesClicked + ' times clicked');
        */
        //if(_this.currentIndex < (_this.data.length -1) && _this.timesClicked < division){
            //_this.timesClicked++;
            _this.currentIndex = _this.currentIndex + _this.itemsPerSlide;
            _this.setCurrentIndex(_this.currentIndex);
        //}
        _this.getFirstShownItem();
    });
}

jvzooCarousel.prototype.getFirstShownItem = function(){
    // console.log(this.currentShownItems);
}

jvzooCarousel.prototype.carouselResize = function(){
    var _this = this;
    $( window ).on('resize', function(e) {
        clearTimeout(_this.resizeTimer);
        _this.resizeTimer = setTimeout(function() {
            //place set widths here
            _this.setItemCount();
        }, 250);
    });
}

jvzooCarousel.prototype.setItemCount = function(){
    var carousel = $(this.element);
    var _this = this;
    var carouselWidth = $(carousel).width();
    //greater than 720 is desktop
    //720 = tablet
    //576 = mobile handset

    if(carouselWidth == 400 || carouselWidth < 400){
        _this.itemsPerSlide = 1;
    }
    if(carouselWidth <= 576 && carouselWidth > 400){
        _this.itemsPerSlide = 2;
    }
    if(carouselWidth <= 720 && carouselWidth > 576){
        _this.itemsPerSlide = 3;
    }
    if(carouselWidth > 720){
        _this.itemsPerSlide = 6;
    }
    /*
    switch(carouselWidth) {
        case 400:
            _this.itemsPerSlide = 1;
            console.log('handset small');
            break;
        case (carouselWidth == 576 || carouselWidth > 400):
            _this.itemsPerSlide = 2;
            alert('test');
            console.log('handset large');
            break;
        case 720:
            console.log('tablet');
            _this.itemsPerSlide = 3;
            break;
        default:
            _this.itemsPerSlide = 6;
            console.log('desktop');
    };
    */
    this.setCurrentIndex(0);
    // console.log(this.currentIndex);
    // console.log(carouselWidth);
    // console.log(carousel.selector);
}

jvzooCarousel.prototype.previous = function(){
    var previousItem = $(this.element +' '+ '.previousItem');
    var _this = this;
    $(previousItem).click(function(){
        // console.log(_this.currentShownItems[0]);
        var indexOfFirstItem = _this.data.indexOf(_this.currentShownItems[0]);
        if(indexOfFirstItem- _this.itemsPerSlide < 0){
            //_this.setCurrentIndex(0);
        }
        else{
            _this.setCurrentIndex(indexOfFirstItem- _this.itemsPerSlide);
        }

        // console.log(indexOfFirstItem + ' is the index of the first item');
        /*
        if(_this.timesClicked !== 1){
            _this.timesClicked--;
        }
        if(_this.currentIndex > 0){
            _this.currentIndex = _this.currentIndex - _this.itemsPerSlide;
            _this.setCurrentIndex(_this.currentIndex);
        }
        */
    });
}

jvzooCarousel.prototype.setCurrentIndex = function(index){
    this.currentIndex = index;
    // console.log(this.itemsPerSlide + ' amounts per slide');
    var value = this.data[index];
    var items;

    if(this.getItemsPerSlide().length !== 0){
        items = this.getItemsPerSlide();
        var widthUl = $(this.element + ' ul').width();

        this.currentShownItems = items;
        var setWidth = 100 / this.itemsPerSlide;
    var htmlTemplate = function(items){
        var stringData ='';
        items.forEach(function(value) {
            // console.log(value);
            stringData += '<li style="width:' + setWidth + '%">' +
                    '<a href="https://www.jvzoo.com/c/1/' + value.product_id + '?tid=newmarketplace">' +
                        '<img src="' + value.product_image + '" alt="">' +
                    '</a>' +
                    '<h2>' + value.product_name +'</h2>' +
                    '<p>' + value.description + '</p>' +
                '</li>';
        }, this);
        // console.log(stringData);
        return stringData;
    };
    //if(htmlTemplate(items).length !== 0){
        $(this.element + ' ul').html(htmlTemplate(items));
    //}
    }

}

jvzooCarousel.prototype.getItemsPerSlide = function(){
    var items = [];
    //get index and get the next [n] items and push inforamtion in.
    var i = 0;

    for(var item in this.data){
        //if(item > this.currentIndex && item < (this.currentIndex + this.getItemsPerSlide)){
        if(item >= this.currentIndex && item < this.currentIndex + this.itemsPerSlide){
            // console.log(this.data[item]);
            // console.log('item is above');
            items.push(this.data[item]);
        }
    }
    return items;
}

jvzooCarousel.prototype.init = function(){
    this.setCurrentIndex(0);
    this.setItemCount();
    this.next();
    this.previous();
    this.carouselResize();
}
